import React from "react";
import PropTypes from "prop-types";
import InputBase from "../Base/InputBase";
import Dropdown from "../Dropdown";
import Calendar from "./Calendar";
import Fa from "../../../tools/Icons/Fa";
import is from "../../../../utils/is";

class DatepickerInput extends InputBase {
	constructor(props) {
		super(props);

		this.state = {
			value: this.state.value || new Date(),
		};

		this.state = {
			...this.state,
			inputValue: this._parseValue(this.state.value || props.defaultValue),
			dropdownVisible: false,
			activeView: props.activeView || "DAYS",
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		const {value} = this.state;

		if(!is.equal(prevState.value, value)) {
			this.setState({inputValue: this._parseValue(new Date(value))});
		}
	}

	render() {
		const {className, path, readOnly, style, disabled} = this.props;
		const {value, dropdownVisible, activeView} = this.state;

		let activeFormat = this._resolveFormat();
		let delimiter = (activeFormat.match(/[^\w]+/g) || []).map(d => d.trim());
		let placeholders = activeFormat.split(delimiter[0] || '.').map(p => p.trim());
		let calendarActiveView = activeFormat.includes("d") ? "DAYS" : (activeFormat.includes("m") ? "MONTHS" : "YEARS");

		return (
			<span className={`datepicker ${className}`} style={style}>
				<Dropdown
					trigger={"manual"}
					name={"dropdown"}
					ref={this.setRef}
					content={<Calendar/>}
					hideOnClick={false}
					onModify={(type, path, value) => this.applyChange(path, value)}
					path={path}
					defaultValue={value}
					closeDropdownOnSelect={false}
					allowedDepth={calendarActiveView}
					activeView={activeView || calendarActiveView}
					visible={dropdownVisible}
					onClose={() => this.setState({dropdownVisible: false})}
				>
					<div
						className={`input-wrapper`}
					>
						{this.renderPrefix()}
						{
							placeholders.map((placeholder, i) => (
								<label key={i}>
									<input
										value={this._getDefaultValue(placeholder) || ''}
										placeholder={placeholder}
										onChange={e => this._handleChange(e.target.value, placeholder)}
										maxLength={placeholder.includes('y') ? 4 : 2}
										readOnly={readOnly || window.innerWidth < 400}
										disabled={disabled}
										onFocus={(e) => {
											e.target.select();
											this.setState({dropdownVisible: true});
										}}
									/>
									{delimiter[i]}
								</label>
							))
						}
						{this.renderSuffix()}
						{this.renderInvalidateButton()}
					</div>
				</Dropdown>
			</span>
		)
	}

	_handleChange(value, placeholder) {
		const {path} = this.props;
		let dict = {
			"dd": "date",
			"mm": "month",
			"yyyy": "year",
		};

		this.setState(state => ({
			inputValue: {
				...state.inputValue,
				[dict[placeholder.trim()]]: parseInt(value)
			}
		}));

		setTimeout(() => {
			let result = this.state.inputValue;
			let date = new Date(result.year || 'Hello,', (result.month || "I'm an hidden") - 1, result.date || 'easter egg');

			if(is.date(date) && is.valid(date) && result.year >= 2000) {
				this.debounceChange(path, date);
			}
		}, 0);
	}

	_getDefaultValue(placeholder) {
		const {inputValue, value} = this.state;

		let date = new Date(value);
		if(is.date(date)) {
			if(placeholder.includes("d")) {
				return inputValue.date;
			}
			else if(placeholder.includes("m")) {
				return inputValue.month;
			}
			else if(placeholder.includes("y")) {
				return inputValue.year;
			}
		}

		return '';
	}

	_parseValue(value) {
		let date = new Date(value);
		return {
			date: date.getDate(),
			month: date.getMonth() + 1,
			year: date.getFullYear()
		}
	}

	_resolveFormat() {
		if(this.props.format) {
			return this.props.format;
		}

		//TODO: if active language doesn't use arabic numbers this will not work!
		let nDate = new Date(null).offset({month: 1, day: 2});
		let dateOutput = nDate.toLocaleDateString(window.translator.getActiveLanguage(true));
		dateOutput = dateOutput.replace(/0?3/, "dd");
		dateOutput = dateOutput.replace(/0?2/, "mm");
		dateOutput = dateOutput.replace(/1970/, "yyyy");
		return dateOutput;
	}

	static get propTypes() {
		return {
			...super.propTypes,
			format: PropTypes.string,
		}
	}

	static get stateTypes() {
		return {
			...super.stateTypes,
		}
	}

	static get defaultProps() {
		return {
			...super.defaultProps,
			prefix: <Fa icon={"calendar"} />,
			onValue: value => value ? new Date(value).toISOString() : value,
		}
	}
}

export default DatepickerInput;
